export const SET_USER_LOGGED_IN = "SET_USER_LOGGED_IN";

export const setUserStatus = (response) => {
  return {
    type: SET_USER_LOGGED_IN,
    payload: response,
  };
};
